import React from 'react';
import PropTypes from 'prop-types';
import AddButton from 'react-jsonschema-form/lib/components/AddButton';
import { getUiOptions } from 'react-jsonschema-form/lib/utils';

function CustomObjectFieldTemplate(props) {
  const canExpand = function canExpand() {
    const { formData, schema, uiSchema } = props;
    if (!schema.additionalProperties) {
      return false;
    }
    const { expandable } = getUiOptions(uiSchema);
    if (expandable === false) {
      return expandable;
    }
    if (schema.maxProperties !== undefined) {
      return Object.keys(formData).length < schema.maxProperties;
    }
    return true;
  };

  const { TitleField, DescriptionField, formContext } = props;


  const isChatMode = formContext && formContext.displayMode === 'chat';
  const isPaginatedMode = formContext && formContext.displayMode === 'paginated';

  const titleValue = props.title || props.uiSchema['ui:title'];
  const hasTitle = titleValue && titleValue.trim() !== '';
  const hasDescription = props.description;
  const isSection = props.idSchema.$id !== 'root';
  const sectionKey = props.idSchema.$id.replace(/.*_/, '');

  return (
    <fieldset className={`${isSection && (isPaginatedMode || isChatMode) ? 'hidden' : ''}`} id={props.idSchema.$id} data-field-key={isSection ? sectionKey : undefined} style={{ ...(isChatMode && { display: 'flex', flexDirection: 'column' }) }}>
      {(hasTitle || hasDescription) && !isSection && (
        <div>
          {hasTitle && (
            <TitleField
              id={`${props.idSchema.$id}__title`}
              title={titleValue}
              required={props.required}
              formContext={props.formContext}
            />
          )}
          {hasDescription && (
            <DescriptionField
              description={props.description}
              formContext={props.formContext}
            />
          )}
        </div>
      )}

      {(hasTitle || hasDescription) && isSection && (isPaginatedMode || isChatMode) && (
        <div id={`${props.idSchema.$id}__title`} className={`field-description ${isChatMode ? 'hidden' : ''}`} data-field-key={sectionKey}>
          {hasTitle && (
            <TitleField
              id={`${props.idSchema.$id}__title`}
              title={titleValue}
              required={props.required}
              formContext={props.formContext}
              style={{ ...(isChatMode && !hasDescription && { marginBottom: '0px' }) }}
            />
          )}
          {hasDescription && (
            <DescriptionField
              description={props.description}
              formContext={props.formContext}
            />
          )}
        </div>
      )}

      {(hasTitle || hasDescription) && isSection && !isPaginatedMode && !isChatMode && (
        <div>
          {hasTitle && (
            <TitleField
              id={`${props.idSchema.$id}__title`}
              title={titleValue}
              required={props.required}
              formContext={props.formContext}
            />
          )}
          {hasDescription && (
            <DescriptionField
              description={props.description}
              formContext={props.formContext}
            />
          )}
        </div>
      )}
      {props.properties.map(prop => prop.content)}
      {canExpand() && (
        <AddButton
          className="object-property-expand"
          onClick={props.onAddClick(props.schema)}
          disabled={props.disabled || props.readonly}
        />
      )}
    </fieldset>
  );
}

CustomObjectFieldTemplate.propTypes = {
  TitleField: PropTypes.isRequired,
  DescriptionField: PropTypes.isRequired,
  properties: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.element.isRequired,
    name: PropTypes.string.isRequired,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
  })).isRequired,
  schema: PropTypes.shape({
    additionalProperties: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.object,
    ]),
    maxProperties: PropTypes.number,
  }).isRequired,
  uiSchema: PropTypes.shape({
    'ui:title': PropTypes.string,
    'ui:options': PropTypes.shape({
      expandable: PropTypes.bool,
    }),
  }).isRequired,
  idSchema: PropTypes.shape({
    $id: PropTypes.string.isRequired,
  }).isRequired,
  formData: PropTypes.object.isRequired,
  formContext: PropTypes.shape({
    displayMode: PropTypes.oneOf(['chat', 'paginated', 'default']),
  }),
  title: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  onAddClick: PropTypes.func.isRequired,
};

CustomObjectFieldTemplate.defaultProps = {
  formContext: {},
  title: undefined,
  description: undefined,
  required: false,
  disabled: false,
  readonly: false,
};

export default CustomObjectFieldTemplate;
